"use client";

import { Button, cn } from "@saridana-core/react-ui-kit";
import { TButtonLink } from "@shared/types";
import Image from "next/image";
import Link from "next/link";

type ButtonLinkVariant = "primary" | "default" | "secondary" | "tertiary" | "quaternary" | "transparent";
type ButtonLinkSize = "lg" | "md";

type Props = TButtonLink & {
  size?: ButtonLinkSize;
  className?: string;
  iconClassName?: string;
};

export function ButtonLink({
  href,
  text,
  target,
  icon,
  iconPosition = "start",
  variant = "default",
  size = "lg",
  className,
  iconClassName,
}: Props) {
  const mapVariantClass: Record<string, string> = {
    primary: "",
    default: "bg-white text-primary hover:text-primary",
    secondary: "bg-secondary-600 hover:bg-secondary-500",
    tertiary: "",
    quaternary: "",
    transparent: "bg-transparent hover:bg-transparent hover:opacity-80 hover:text-initial",
  };

  const mapSizeClass: Record<ButtonLinkSize, string> = {
    md: "text-base md:text-lg h-12 md:h-[50px] md:px-6",
    lg: "text-lg md:text-xl h-14 md:h-[60px] md:px-8",
  };

  const mapVariant: Record<ButtonLinkVariant, any> = {
    default: "outline",
    primary: "default",
    secondary: "secondary",
    tertiary: "tertiary",
    quaternary: "quaternary",
    transparent: "outline",
  };

  return (
    <Button
      variant={mapVariant[variant]}
      className={cn("rounded-xl py-4 px-6 font-bold", mapVariantClass[variant], mapSizeClass[size], className || "")}
      asChild
    >
      <Link href={href} target={target || "_self"}>
        {icon && icon.data && iconPosition === "start" && (
          <Image
            className={cn("size-7 mr-1", iconClassName)}
            src={icon?.data?.attributes?.url || ""}
            alt={icon?.data?.attributes?.alternativeText || icon?.data?.attributes?.name || "Button Link"}
            width={icon?.data?.attributes?.width || 28}
            height={icon?.data?.attributes?.height || 28}
          />
        )}
        <span>{text}</span>
        {icon && icon.data && iconPosition === "end" && (
          <Image
            className={cn("size-7 mr-1", iconClassName)}
            src={icon?.data?.attributes?.url || ""}
            alt={icon?.data?.attributes?.alternativeText || icon?.data?.attributes?.name || "Button Link"}
            width={icon?.data?.attributes?.width || 28}
            height={icon?.data?.attributes?.height || 28}
          />
        )}
      </Link>
    </Button>
  );
}
